import * as React from 'react';

const SvgSearch = (props) => (
  <svg
    width={18}
    height={19}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.75}>
      <path
        d="M11.25 12.1224L15 15.8724M12.5 8.62244C12.5 5.99908 10.3734 3.87244 7.75 3.87244C5.12665 3.87244 3 5.99908 3 8.62244C3 11.2458 5.12665 13.3724 7.75 13.3724C10.3734 13.3724 12.5 11.2458 12.5 8.62244Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgSearch;
